import api from '../../../../../api/client';
import { PAYMENT_ACCOUNT } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getMzadcomAccountList(params = {}) {
  try {
    const response = await api.get(PAYMENT_ACCOUNT.LIST, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getPaymentAccount(params = {}) {
  try {
    const response = await api.get(PAYMENT_ACCOUNT.INDEX, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
export async function createPaymentAccount(payload = {}) {
  try {
    const response = await api.post(PAYMENT_ACCOUNT.STORE, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function updatePaymentAccount(id, payload = {}) {
  try {
    const response = await api.put(PAYMENT_ACCOUNT.UPDATE(id), payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function actionPaymentAccount(id, payload = {}) {
  try {
    const response = await api.patch(PAYMENT_ACCOUNT.ACTION(id), payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getPaymentAccountConfig(params = {}) {
  try {
    const response = await api.get(PAYMENT_ACCOUNT.CONFIG, {
      params,
    });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function updatePaymentAccountConfig(id, payload = {}) {
  try {
    const response = await api.put(PAYMENT_ACCOUNT.CONFIG_UPDATE(id), payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
